module.exports = __webpack_public_path__ + "img/tarj2-14.dcd4708b.svg";